<template>
	<div class="card box-shadow-sm">
		<div class="card-header">
			<form @submit.prevent class="mt-3">
        <div class="row photoHeader">
          <img id="blah"
            style=" border-radius: 50px; width: 60px!important;height: 60px!important;"
            class="rounded-circle border"
            onerror="this.src='/static/assets/front-end/img/image-place-holder.png'"
            :src="account.picture || '/static/assets/front-end/img/image-place-holder.png'" 
          />
          <div class="col-md-10 pl-2 align-self-center">
            <h5 class="font-name">{{ account.name }}</h5>
            <span class="text-muted">( ID: {{ account.id }} )</span>
            <label for="files"
              style="cursor: pointer; color:var(--primary_color);"
              class="spandHeadO">
            </label>
          </div>
          <div class="card-body mt-md-3" style="padding: 0px;">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>{{ t("users.name") }}</label>
                <input v-model="account.name" type="text" class="form-control" required>
              </div>
              <!-- <div class="form-group col-md-6">
                  <label>姓氏</label>
                  <input v-model="account.family_name" type="text" class="form-control">
              </div>
              <div class="form-group col-md-6">
                  <label>名字</label>
                  <input v-model="account.given_name" type="text" class="form-control">
              </div> -->
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Email</label>
                <input v-model="account.email" type="email" class="form-control" disabled>
              </div>
              <div class="form-group col-md-6">
                <label>{{ t("users.phone") }}</label>
                <input v-model="account.phone_number" type="text" class="form-control" disabled>
              </div>
            </div>
            <button class="btn btn-primary float-right" @click="editProfile">{{ t("global.update") }}</button>
          </div>
        </div>
      </form>
		</div>
	</div>
</template>

<script setup>
  import { useI18n } from "vue-i18n"
import { notificationErrors } from "../../utils"
import { ElNotification } from 'element-plus'
import { _api_patchAuthProfile } from "../../api/index.js"

const props = defineProps({
  account: Object
})

const { t, n, locale } = useI18n()

const editProfile = async () => {
  window.fullPageLoading("show")
  try {
    await _api_patchAuthProfile(props.account)
    ElNotification({
      title: t("users.updateSuccess"),
      type: 'success',
      position: 'bottom-left',
    })
  } catch (err) {
    console.log("editProfile Fail: ", err)
    notificationErrors(err.response.data)
  } finally {
    window.fullPageLoading("hide")
  }
}
</script>